'use client'

import { Flex, Spinner } from '@chakra-ui/react'
import {
  useGetDonorCardDetailQuery,
  useGetDonorDetailQuery,
} from '@entities/donor/api/get-donor.api'
import { DonorDonationHistoryCard } from '@/widgets/donor/DonorDonationHistoryCard'

interface Props {
  visitId: string
}

/** «Донация» — every donation of the donor, from `donation_history`. */
export function DonationTab({ visitId }: Props) {
  const { data: donorDetail, isPending: donorDetailPending } =
    useGetDonorDetailQuery(visitId)
  const { data: donorCard, isPending: donorCardPending } =
    useGetDonorCardDetailQuery(donorDetail?.donor_id ?? '')

  if (donorDetailPending || donorCardPending) {
    return (
      <Flex justify="center" align="center" minH="200px">
        <Spinner size="lg" color="primary.fg" />
      </Flex>
    )
  }

  return (
    <DonorDonationHistoryCard donations={donorCard?.donation_history ?? []} />
  )
}
